export const language_zh={
    "nav.home": "首页",
    "nav.cexs": "CEXs 和核心团队",
    "nav.operations": "操作",
    "nav.transactions": "交易",
    "nav.blocks": "区块",
    "nav.nodes": "节点",
    "nav.nodes_mainnet": "主网节点",
    "nav.nodes_testnet": "测试网节点",
    "nav.stats": "统计",
    "nav.defi": "DeFi",
    "nav.assets": "资产",
    "nav.pools": "流动性池",
    "nav.trades": "交易",
    "stats.accounts": "账户分布",
    "stats.unlocks": "Pi 解锁 (30 天)",
    "stats.monthly_unlocks": "Pi 解锁 (月度)",
    'stats.domain_auction': '域名拍卖',
     "stats.largest_tx": "最大交易",
"stats.migrate": "主网迁移统计",
    "search.placeholder": "搜索...",
    'operations.self_transfer': '自我转账',
    'operations.domain_auction': '域名拍卖',
    "operations.claim_claimable_balance": "领取 π",
    "operations.create_account": "创建账户",
    "operations.payment": "支付",
    "operations.path_payment_strict_receive": "严格接收路径支付",
    "operations.path_payment_strict_send": "严格发送路径支付",
    "operations.manage_sell_offer": "管理卖出报价",
    "operations.create_passive_sell_offer": "创建被动卖出报价",
    "operations.set_options": "设置选项",
    "operations.change_trust": "更改信任",
    "operations.allow_trust": "允许信任",
    "operations.account_merge": "账户合并",
    "operations.inflation": "通货膨胀",
    "operations.manage_data": "管理数据",
    "operations.bump_sequence": "提升序列",
    "operations.manage_buy_offer": "管理买入报价",
    "operations.create_passive_buy_offer": "创建被动买入报价",
    "operations.create_claimable_balance": "创建可领取余额",
    "operations.claim_claimable_balance_atom": "领取余额",
    "operations.deposit": "存入",
    "operations.withdraw": "提取",
    "operations.pay": "支付",
    "operations.to": "至",
    "operations.from": "从",
    "operations.claimant": "领取人",
    "operations.with_starting_balance": "起始余额为",
    "operations.claim": "领取",
    "operations.heading": "探索 Pi 网络区块链上的最新操作",
    "operations.title": "Pi 网络上的最新操作",
    "operations.description": "探索 Pi 网络区块链上的最新操作。",
    "operations.source_account": "源账户",
    "operations.operation": "操作",
    "operations.amount": "数量",
    "operations.tx": "交易",
    "operations.time": "时间",
    "pagination.previous": "上一页",
    "pagination.next": "下一页",
    "pagination.page": "页码",
    "account.title": "账户 {{address}} - Pi 网络浏览器",
    "account.heading": "账户详情",
    "account.heading_with_address": "账户 {{address}}",
    "account.description": "Pi 网络上账户 {{address}} 的详细信息。",
    "account.loading": "加载账户详情中...",
    "account.not_found": "找不到账户。",
    "account.scam_warning_title": "诈骗警告",
    "account.scam_warning_description": "根据社区报告，此钱包地址已被标记为不安全。它可能与诈骗、私钥泄露或未授权访问有关。在进行任何交易前请谨慎行事。",
    "account.overview": "概览",
    "account.available_balance": "可用余额",
    "account.last_modified_time": "最后修改时间",
    "account.locking": "锁定中",
    "account.total_locking": "总锁定 ({{count}} 项)",
    "account.next_unlock_time": "下次解锁时间",
    "account.claimable": "可领取",
    "account.amount": "金额",
    "account.number_of_items": "项目数量",
    "account.over_100_items": "超过100项",
    "account.tx_hash": "交易哈希",
    "account.operation_count": "操作数量",
    "account.fee": "费用",
    "account.created_at": "创建时间",
    "account.account": "账户",
    "account.effect": "效果",
    "account.sponsor": "赞助商",
    "account.predicate": "条件",
    "account.create_time": "创建时间",
    "account.latest_100_claimable": "最新100个可领取余额",
    "account.tabs.operations": "操作",
    "account.tabs.transactions": "交易",
    "account.tabs.effects": "效果",
    "account.tabs.claimable_balances": "可领取余额",
    "effects.account_credited": "账户已入账",
    "effects.account_debited": "账户已扣款",
    "effects.account_created": "账户已创建",
    "effects.claimable_balance_created": "可领取余额已创建",
    "effects.claimable_balance_claimed": "可领取余额已领取",
    "effects.claimable_balance_claimant_created": "可领取余额领取人已创建",
    "effects.account_removed": "账户已删除",
    "effects.account_thresholds_updated": "账户阈值已更新",
    "effects.account_home_domain_updated": "账户主域名已更新",
    "effects.account.flags_updated": "账户标志已更新",
    "effects.account_inflation_destination_updated": "账户通胀目标已更新",
    "effects.signer_created": "签署人已创建",
    "effects.signer_removed": "签署人已删除",
    "effects.signer.updated": "签署人已更新",
    "effects.trustline_created": "信任线已创建",
    "effects.trustline_removed": "信任线已删除",
    "effects.trustline.updated": "信任线已更新",
    "effects.trustline_authorized": "信任线已授权",
    "effects.trustline.deauthorized": "信任线已取消授权",
    "effects.offer_created": "报价已创建",
    "effects.offer_removed": "报价已删除",
    "effects.offer.updated": "报价已更新",
    "effects.trade": "交易已执行",
    "effects.data.created": "数据已创建",
    "effects.data.removed": "数据已删除",
    "effects.data.updated": "数据已更新",
    "effects.sequence_bumped": "序列已提升",
    "effects.liquidity_pool_created": "流动性池已创建",
    "effects.liquidity_pool_removed": "流动性池已删除",
    "effects.liquidity_pool_deposited": "流动性池已存入",
    "effects.liquidity_pool_withdrew": "流动性池已提取",
    "effects.liquidity_pool_trade": "流动性池交易",
    "effects.liquidity_pool_revoked": "流动性池已撤销",
    "effects.contract_credited": "合约已入账",
    "effects.contract_debited": "合约已扣款",
    "effects.claimable_balance_sponsorship_removed": "可领取余额赞助已移除",
    "account_stats.heading": "Pi 账户统计 - 余额分布和顶级账户",
    "account_stats.title": "Pi 账户统计 - 余额分布和顶级账户",
    "account_stats.description": "查看 Pi 网络上最富有的 Pi 账户和整体余额分布。",
    "account_stats.intro_text": "探索所有账户中 Pi 的分布并查看顶级 Pi 持有者。",
    "account_stats.distribution_chart_title": "Pi 持有者分布",
    "account_stats.categories_title": "分布类别",
    "account_stats.top_accounts_title": "顶级 Pi 账户",
    "account_stats.accounts": "账户",
    "account_stats.of_total": "占总数",
    "account_stats.table.category": "类别",
    "account_stats.table.balance_range": "余额范围",
    "account_stats.table.usd_value": "美元价值",
    "account_stats.table.accounts": "账户数",
    "account_stats.table.percentage": "总数百分比",
    "account_stats.table.total": "总计",
    "account_stats.table.rank": "排名",
    "account_stats.table.account": "账户",
    "account_stats.table.balance": "余额",
    "account_stats.table.value": "价值",
    "account_stats.table.supply_percentage": "总供应量百分比",
    "account_stats.categories.whales": "鲸鱼",
    "account_stats.categories.sharks": "鲨鱼",
    "account_stats.categories.dolphins": "海豚",
    "account_stats.categories.tunas": "金枪鱼",
    "account_stats.categories.fish": "鱼",
    "account_stats.categories.shrimps": "虾",
    "account_stats.categories.plankton": "浮游生物",
    "account_stats.categories.microbes": "微生物",
    "number.billion_short": "亿",
    "number.million_short": "百万",
    "number.thousand_short": "千",
    "common.loading": "加载中...",
    "common.sponsored": "赞助",
    "common.ad": "广告",
    "common.ad_not_available": "您所在地区无法提供赞助内容",
    "blocks.heading": "探索 Pi 网络区块链上的最新区块",
    "blocks.title": "Pi 网络上的最新区块",
    "blocks.description": "探索 Pi 网络区块链上的最新区块。",
    "blocks.sequence": "序列",
    "blocks.hash": "哈希",
    "blocks.transactions": "交易",
    "blocks.operations": "操作",
    "blocks.time": "时间",
    "blocks.successful": "成功",
    "blocks.failed": "失败",
    "block.title": "区块 #{{sequence}} - Pi 网络浏览器",
    "block.heading": "区块 #{{sequence}}",
    "block.description": "Pi 网络区块链上区块 #{{sequence}} 的详细信息。",
    "block.loading": "加载区块详情中...",
    "block.not_found": "找不到区块。",
    "block.information": "区块信息",
    "block.hash": "哈希",
    "block.previous_hash": "前序哈希",
    "block.sequence": "序列",
    "block.time": "时间",
    "block.total_coins": "总币量",
    "block.fee_pool": "手续费池",
    "block.base_fee": "基础手续费",
    "block.base_reserve": "基础准备金",
    "block.protocol_version": "协议版本",
    "block.tx_hash": "交易哈希",
    "block.operation_count": "操作数量",
    "block.fee": "手续费",
    "block.created_at": "创建时间",
    "block.tabs.transactions": "交易",
    "block.tabs.operations": "操作",
    "block.tabs.effects": "效果",
    "cex.heading": "CEX 和核心团队账户统计",
    "cex.title": "Pi 网络上的 CEX 和核心团队账户",
    "cex.description": "探索 Pi 网络区块链上的 CEX 和核心团队账户。",
    "cex.wallet_balances": "CEX 钱包余额",
    "cex.core_team_wallets": "Pi 核心团队钱包",
    "cex.cmc_ranking": "CMC 排名",
    "cex.exchange": "交易所",
    "cex.chart_link": "图表链接",
    "cex.signup_link": "注册链接",
    "cex.wallet_address": "钱包地址",
    "cex.balance_pi": "余额 (Pi)",
    "cex.balance_usd": "余额 (USD)",
    "cex.chart": "图表",
    "cex.signup": "注册",
    "cex.total": "总计",
    "cex.note": "备注",
    "cex.pi_foundation": "Pi 基金会",
    "cex.team_wallet_footnote": "由于数量庞大且交易极少，这里未列出约 10,000 个标记为属于 Pi 核心团队的账户。每个钱包持有约 2,000,000 Pi，总计约 200 亿 Pi 尚未计入。",
   'cex.total_in': '总流入（近24小时）',
'cex.total_out': '总流出（近24小时）',
'cex.net_difference': '净流量（近24小时）',
'cex.flow_data_updated': '数据每30分钟更新一次',
'cex.flow_note': '基于近24小时数据，每30分钟自动更新。',

    "contact.heading": "联系我们",
    "contact.title": "联系 PiScan",
    "contact.description": "如有任何疑问或反馈，请联系 PiScan。",
    "contact.intro_text": "如果您有任何问题，请随时通过以下方式联系我们",
    "contact.success_message": "感谢您与我们联系！我们将尽快回复您。",
    "contact.form.name": "您的姓名",
    "contact.form.email": "您的电子邮箱",
    "contact.form.message": "消息",
    "contact.form.submit": "发送消息",
    "home.heading": "探索 Pi 网络交易、钱包和统计数据",
    "home.title": "探索 Pi 网络交易、钱包和统计数据",
    "home.description": "探索 Pi 网络交易、钱包和统计数据",
    "home.market_cap": "市值",
    "home.price": "价格",
    "home.24h_change": "24小时变化",
    "home.pi_supply": "Pi 供应量",
    "home.circulating": "流通量",
    "home.locked": "锁定量",
    "home.cex_balance_total": "CEX 余额 (总计)",
    "home.view_all": "查看全部",
    "home.network_stats": "网络统计",
    "home.blocks": "区块",
    "home.tps": "TPS",
    "home.latest_transactions": "最新交易",
    "home.signature": "签名",
    "home.time": "时间",
    "home.block": "区块",
    "home.ops": "操作",
    "home.latest_operations": "最新操作",
    "home.source_account": "源账户",
    "home.operation": "操作",
    "home.amount": "数量",
    "home.tx": "交易",
    "nodes.heading": "Pi 网络节点地图和网络统计",
    "nodes.title": "Pi 网络节点和验证者",
    "nodes.description": "探索 Pi 网络节点、验证者和网络拓扑。查看节点的全球分布和连接性。",
    "nodes.active_nodes": "活跃节点",
    "nodes.validators": "验证者",
    "nodes.known_peers": "已知对等点",
    "nodes.disconnected_nodes": "断开连接节点",
    "nodes.network_graph": "网络图",
    "nodes.node_types": "节点类型",
    "nodes.validator": "验证者",
    'nodes.phantom_validators': '不可达验证者',
    "nodes.watcher": "观察者",
    "nodes.disconnected_private": "断开连接/私有",
    "nodes.click_to_highlight": "点击节点以突出显示其连接",
    "nodes.global_distribution": "全球分布",
    "nodes.mapped_nodes": "已映射节点",
    "nodes.node_details": "节点详情",
    "nodes.nodes": "节点",
    "nodes.address": "地址",
    "nodes.type": "类型",
    "nodes.location": "位置",
    "nodes.isp": "互联网服务提供商",
    "nodes.version": "版本",
    "nodes.trust": "信任",
    "nodes.trusted_by": "被信任",
    "nodes.status": "状态",
    "nodes.status.connected": "已连接",
    "nodes.status.disconnected": "已断开",
    "nodes.status.private": "私有",
    "nodes.active_quorum_sets": "活跃法定人数集",
    "nodes.active": "活跃",
    "nodes.quorum_hash": "法定人数哈希",
    "nodes.node_id": "节点 ID",
    "nodes.unknown": "未知",
    "nodes.core_team": "核心团队",
    "nodes.tooltip.node_id": "节点 ID",
    "nodes.tooltip.address": "地址",
    "nodes.tooltip.type": "类型",
    "nodes.tooltip.status": "状态",
    "nodes.tooltip.version": "版本",
    "nodes.tooltip.location": "位置",
    "nodes.tooltip.not_accessible": "无法访问",
    "nodes.country_statistics": "国家统计",
    "nodes.country": "国家",
    "nodes.connected_nodes": "已连接节点",
    "nodes.no_country_data": "没有可用的国家数据",
    "nodes.city_statistics": "城市统计",
    "nodes.city": "城市",
    "nodes.no_city_data": "没有可用的城市数据",
    "nodes.online_nodes_only": "仅在线节点",
    
    // 测试网节点翻译
    "nodes_testnet.heading": "Pi 测试网节点统计和网络分析",
    "nodes_testnet.title": "Pi 测试网节点和网络统计",
    "nodes_testnet.description": "探索 Pi 测试网节点统计、地理分布和网络活动指标。",
    "nodes_testnet.total_nodes": "总节点数",
    "nodes_testnet.active_nodes": "活跃节点",
    "nodes_testnet.inactive_nodes": "非活跃节点",
    "nodes_testnet.last_updated": "最后更新",
    "nodes_testnet.country_statistics": "国家统计",
    "nodes_testnet.city_statistics": "城市统计",
    "nodes_testnet.country": "国家",
    "nodes_testnet.city": "城市",
    "nodes_testnet.active_rate": "活跃率",
    "nodes_testnet.summary_title": "网络概览",
    "nodes_testnet.summary_description": "Pi 测试网节点分布和全球网络活动概览。",
    "nodes_testnet.total_peers": "总对等节点",
    "nodes_testnet.active_peers": "活跃对等节点",
    "nodes_testnet.activity_rate": "活跃率",
    
    "report_scam.heading": "举报诈骗钱包",
    "report_scam.title": "在 PiScan 上举报诈骗钱包",
    "report_scam.description": "举报涉及欺诈或诈骗活动的钱包地址。",
    "report_scam.intro_text": "如果您遇到了涉及欺诈或诈骗活动的可疑钱包地址，请使用以下表格进行举报。我们的团队将审核您的提交，如果确认为诈骗，我们将在 PiScan 上将该钱包标记为“诈骗”，以警示社区。",
    "report_scam.success_message": "感谢您的举报！我们的团队将尽快审核。",
    "report_scam.form.wallet_address": "钱包地址",
    "report_scam.form.wallet_placeholder": "输入诈骗钱包地址",
    "report_scam.form.reason": "举报原因",
    "report_scam.form.reason_placeholder": "描述为什么怀疑此钱包涉及诈骗活动",
    "report_scam.form.email": "您的电子邮箱（可选）",
    "report_scam.form.email_placeholder": "输入您的电子邮箱（可选）",
    "report_scam.form.email_note": "我们可能会联系您了解更多详情。",
    "report_scam.form.submit": "提交举报",
    "transaction.title": "Pi 网络上的交易 #{{id}}",
    "transaction.heading": "交易详情",
    "transaction.description": "Pi 网络区块链上交易 #{{id}} 的详细信息。",
    "transaction.loading": "正在加载交易详情...",
    "transaction.not_found": "未找到交易。",
    "transaction.hash": "哈希值",
    "transaction.ledger_block": "账本（区块）",
    "transaction.result": "结果",
    "transaction.source_account": "源账户",
    "transaction.fee_account": "手续费账户",
    "transaction.fee": "手续费",
    "transaction.operation_count": "操作数量",
    "transaction.summary": "摘要",
    "transaction.operations": "操作",
    "transaction.effects": "效果",
    "transaction.account": "账户",
    "transaction.operation": "操作",
    "transaction.effect": "效果",
    "transaction.amount": "金额",
    "transaction.successful": "成功",
    "transaction.failed": "失败",
    "transaction.loading_details": "正在加载交易详情...",
    "transaction.with_operations": "包含 {{count}} 个操作的交易",
    "transaction.core_team_distributed": "Pi 核心团队分发了",
    "transaction.to": "给",
    "transaction.accounts": "账户",
    "transaction.locked_for_days": "，锁定 {{days}} 天",
    "transaction.locked_range_days": "，锁定期从 {{minDays}} 天到 {{maxDays}} 天不等",
    "transaction.created_at": "创建时间",
    "unlock_stats.heading": "Pi 解锁统计 - 未来 30 天",
    "unlock_stats.title": "Pi 解锁统计 - 未来 30 天",
    "unlock_stats.description": "查看未来 30 天的 Pi 加密货币解锁统计预测。",
    "unlock_stats.intro_text": "未来 30 天的 Pi 解锁基于可领取余额——可能是用户锁定的或由 Pi 核心团队分配的。尚未包含在可领取余额中的未发布 Pi 无法追踪。请定期查看更新。所有时间均为 UTC。",
    "unlock_stats.today_note": "今天的解锁金额代表从现在到当天结束（UTC）将要解锁的剩余 Pi。",
    "unlock_stats.updated_at": "数据更新于：",
    "unlock_stats.unknown": "未知",
    "unlock_stats.total_locked": "总锁定 Pi",
    "unlock_stats.total_next_30": "未来 30 天总解锁量",
    "unlock_stats.of_total_locked": "占总锁定量",
    "unlock_stats.avg_daily": "平均每日解锁量",
    "unlock_stats.per_day": "每天",
    "unlock_stats.highest_day": "最高解锁日",
    "unlock_stats.on": "在",
    "unlock_stats.chart_title": "Pi 解锁图表 - 未来 30 天",
    "unlock_stats.data_table": "解锁数据表",
    "unlock_stats.date": "日期",
    "unlock_stats.amount": "金额",
    "unlock_stats.value": "价值",
    "unlock_stats.pi_unlock": "Pi 解锁",
    "unlock_stats.y_axis_label": "Pi 解锁（百万计）",
    "unlock_stats.monthly_heading": "每月Pi解锁统计",
    "unlock_stats.monthly_title": "每月Pi解锁统计",
    "unlock_stats.total_next_12": "未来 12 个月总解锁量",
    "unlock_stats.monthly_description": "查看每月Pi加密货币解锁统计",
    "unlock_stats.monthly_intro_text": "查看按月统计的Pi加密货币解锁情况。",
    "unlock_stats.monthly_note": "统计基于符合条件的解锁请求。",
    "unlock_stats.monthly_chart_title": "每月Pi解锁统计图表",
    "unlock_stats.total_forecast": "总统计",
    "unlock_stats.monthly_data_table": "每月解锁数据",
    "unlock_stats.total_locking": "总锁定量",
    "unlock_stats.avg_monthly": "每月平均",
    "unlock_stats.highest_month": "最高月份",
    "unlock_stats.per_month": "每月",
    "unlock_stats.in": "于",
    "unlock_stats.month": "月份",
    "unlock_stats.view_daily": "查看每日解锁统计",
    "unlock_stats.view_monthly": "查看每月解锁统计",
    "common.loading_error": "加载数据时出错。请稍后再试。",
    'settings.aria_label': '打开设置',
    'settings.language': '语言',
    'settings.appearance': '外观',
    'settings.dark_mode': '深色模式',
    'settings.light': '浅色',
    'settings.dark': '深色',

    "transactios.heading": "探索 Pi 网络区块链上的最新交易",
    "transactions.title": "Pi 网络上的最新交易",
    "transactions.description": "探索 Pi 网络区块链上的最新交易。",

    "domain_auction_stats.heading": "Pi 域名拍卖统计",
"domain_auction_stats.title": "Pi 域名拍卖统计 | Pi 网络统计",
"domain_auction_stats.description": "分析 Pi 网络域名拍卖，显示不同价格区间的出价分布以及目前已出价的 Pi 总额。",
"domain_auction_stats.intro_text": "本页面提供 Pi 域名拍卖分析，重点展示不同价格区间的出价分布。",
"domain_auction_stats.last_updated": "最后更新",
"domain_auction_stats.summary_title": "拍卖出价概览",
"domain_auction_stats.total_bids": "总出价次数",
"domain_auction_stats.total_pi_bid": "已出价 Pi 总额",
"domain_auction_stats.estimated_value": "预估价值 (USD)",
"domain_auction_stats.pi_price": "当前 Pi 价格",
"domain_auction_stats.distribution_title": "出价分布",
"domain_auction_stats.chart_title": "出价价格分布",
"domain_auction_stats.details_title": "实时出价明细",
"domain_auction_stats.bids": "出价",
"domain_auction_stats.of_total": "占总出价",
"domain_auction_stats.bid_count": "出价次数",
"domain_auction_stats.ranges.low": "低额出价",
"domain_auction_stats.ranges.medium": "标准出价",
"domain_auction_stats.ranges.high": "高级出价",
"domain_auction_stats.ranges.premium": "尊享出价",
"domain_auction_stats.ranges.elite": "顶级出价",
"domain_auction_stats.table.price_range": "出价区间",
"domain_auction_stats.table.bid_count": "出价次数",
"domain_auction_stats.table.percentage": "占比",
"domain_auction_stats.table.total": "总出价",
"domain_auction_stats.highest_bid": "最高出价",
"domain_auction_stats.top_bids_title": "最高出价列表",
"domain_auction_stats.table.account": "账户",
"domain_auction_stats.table.bid_amount": "出价金额",
"domain_auction_stats.table.usd_value": "美元价值",

"largest_tx.heading": "最大 Pi 交易（过去 24 小时）",
"largest_tx.title": "过去 24 小时内最大 Pi 交易 - PiScan",
"largest_tx.description": "探索过去 24 小时 Pi Network 区块链上的最大 Pi 交易。",
"largest_tx.list_heading": "按交易金额排名（过去 24 小时）",
"largest_tx.rank": "排名",
"largest_tx.transaction": "交易",
"largest_tx.account": "账户",
"largest_tx.amount": "金额 (π)",
"largest_tx.date": "日期 & 时间",
"largest_tx.no_data": "过去 24 小时内无交易数据。",
"largest_tx.fetch_error": "无法获取交易数据。",
"largest_tx.loading": "正在加载最大交易...",
"largest_tx.largest_amount": "最大交易金额（过去 24 小时）",
"largest_tx.latest_large_tx": "最新大额交易（过去 24 小时）",
"largest_tx.total_value": "总价值（前 100 笔交易，过去 24 小时）",

"migrate_stats.heading": "Pi 迁移统计",
"migrate_stats.title": "Pi 迁移至主网统计 - PiScan",
"migrate_stats.description": "跟踪最近几天 Pi 迁移至主网的统计数据。",
"migrate_stats.last_updated": "最后更新",

"migrate_stats.daily_migration": "每日迁移量",
"migrate_stats.daily_stats": "每日迁移统计",
"migrate_stats.loading": "正在加载迁移统计...",
"migrate_stats.no_data": "暂无迁移数据。",
"migrate_stats.fetch_error": "无法获取迁移数据。",
"migrate_stats.date": "日期",
"migrate_stats.amount": "金额 (π)",
"migrate_stats.percentage": "百分比 (%)",
"migrate_stats.total": "总计",
"migrate_stats.pi_migrated": "已迁移总 Pi",
"migrate_stats.date_label": "日期：{{date}}",
"migrate_stats.usd_value": "美元价值",
"migrate_stats.at_price": "当前价格",
"migrate_stats.current_price_note": "美元价值按当前 Pi 价格 {{price}} 每 π 计算。",
    "transactions_filter.heading": "筛选交易",
"transactions_filter.title": "筛选交易 | Pi Scan",
"transactions_filter.description": "根据地址、金额和其他条件筛选并搜索 Pi Network 交易。",
"transactions_filter.address_required_error": "请输入地址。",
"transactions_filter.min_amount_required_error": "请输入最小金额。",
"transactions_filter.amount_too_low_error": "金额不能少于 10,000。",
"transactions_filter.min_exceeds_max_error": "最小金额不能超过最大金额。",
"transactions_filter.filter_options": "筛选选项",
"transactions_filter.address": "地址",
"transactions_filter.address_placeholder": "输入账户地址",
"transactions_filter.min_amount": "最小金额 (Pi)",
"transactions_filter.min_amount_placeholder": "例如：10000",
"transactions_filter.max_amount": "最大金额 (Pi)",
"transactions_filter.max_amount_placeholder": "例如：100000",
"transactions_filter.apply_filters": "应用",
"transactions_filter.clear": "清除",
"transactions_filter.no_results": "未找到符合条件的交易。",
"transactions_filter.results": "结果",
"transactions_filter.table.hash": "交易哈希",
"transactions_filter.table.time": "时间",
"transactions_filter.table.from": "发送方",
"transactions_filter.table.to": "接收方",
"transactions_filter.table.amount": "金额 (Pi)",
"transactions_filter.apply_filters_prompt": "请先应用筛选以查看结果。",

// Assets page translations
'assets.heading': 'Pi网络资产 (代币)',
'assets.title': 'Pi网络资产 (代币)',
'assets.description': '探索Pi网络区块链上的所有资产 (代币)',
'assets.total_assets': '总资产 (代币)',
'assets.showing_results': '显示 {{count}} / {{total}} 个资产',
'assets.search_placeholder': '按资产代码或发行者搜索...',
'assets.assets_list': '资产列表',
'assets.previous': '上一页',
'assets.next': '下一页',
'assets.asset_code': '资产代码',
'assets.type': '类型',
'assets.issuer': '发行者',
'assets.accounts': '账户',
'assets.holders': '持有者',
    'assets.total_supply': 'Total Supply',
    'assets.in_pools': '在流动池中',
    'assets.circulating': '流通',
    'assets.pools': 'Pools',
'assets.actions': '链接',
'assets.view_toml': '查看TOML',
'assets.testnet_warning': '这些是测试网代币，没有实际价值',

// Trades page translations
'trades.heading': 'Pi网络交易',
'trades.title': 'Pi网络交易',
'trades.description': '探索Pi网络区块链上的交易活动',
'trades.total_trades': '交易活动',
'trades.showing_results': '显示 {{count}} / {{total}} 笔交易',
'trades.search_placeholder': '按资产或账户搜索...',
'trades.trades_list': '最近交易',
'trades.exchange_rates': '汇率摘要',
'trades.latest_rates': '来自最近交易的最新汇率',
'trades.previous': '上一页',
'trades.next': '下一页',
'trades.time': '时间',
'trades.type': '类型',
'trades.summary': '交易摘要',
'trades.trading_pair': '交易对',
'trades.amount': '数量',
'trades.price': '价格',
'trades.accounts': '账户',
'trades.links': '链接',
'trades.sell_order': '卖出',
'trades.buy_order': '买入',
'trades.base': '基础',
'trades.counter': '计价',
'trades.operation': '操作',
'trades.view_operation': '查看操作详情',

// Asset Detail page translations
'assetDetail.heading': '资产详情',
'assetDetail.back_to_assets': '返回资产列表',
'assetDetail.asset_info': '资产信息',
'assetDetail.total_supply': '总供应量',
    'assetDetail.holders': 'Holders',
    'assetDetail.liquidity_pools': 'Liquidity Pools',
    'assetDetail.claimable_balances': 'Claimable Balances',
    'assetDetail.in_pools': '在流动池中',
    'assetDetail.circulating': '流通',
'assetDetail.trades': '交易',
'assetDetail.search_trades': '搜索交易...',
'assetDetail.previous': '上一页',
'assetDetail.next': '下一页',
'assetDetail.time': '时间',
'assetDetail.type': '类型',
'assetDetail.summary': '摘要',
'assetDetail.price': '价格',
'assetDetail.accounts': '账户',
'assetDetail.links': '链接',
'assetDetail.base': '基础',
'assetDetail.counter': '对手',
'assetDetail.sell': '卖出',
'assetDetail.buy': '买入',
'assetDetail.operation': '操作',
'assetDetail.view_operation': '查看操作',
'assetDetail.liquidity_pools_list': '流动性池列表',
'assetDetail.pool_id': '池ID',
'assetDetail.reserves': '储备',
'assetDetail.total_shares': '总份额',
'assetDetail.fee': '费用',
'assetDetail.trustlines': '信任线',
'assetDetail.last_modified': '最后修改',
'assetDetail.transactions': '交易记录',
'assetDetail.operations': '操作',
'assetDetail.view_transactions': '查看交易',
'assetDetail.view_operations': '查看操作',
'assetDetail.history': '历史',
'assetDetail.no_pools_found': '未找到流动性池',
'assetDetail.testnet_warning': '测试网数据：',
'assetDetail.testnet_description': '这些是测试网活动，可能不反映主网活动。',
'maintenance.heading': 'PiScan 正在进行系统维护，暂时无法访问',
'maintenance.title': 'PiScan - 维护公告',
'maintenance.description': 'PiScan 正在完成协议升级至版本 23，因此暂时暂停服务。',
'maintenance.status': '服务更新',
'maintenance.page_title': 'PiScan 系统升级正在进行中',
'maintenance.message': '协议升级至版本 23 的过程比最初预期需要更长时间。本次升级会影响索引基础设施和链上数据分析服务。因此，PiScan 将暂时暂停服务数日，以完成升级并进行验证。',
'maintenance.protocol_label': '协议版本',
'maintenance.protocol_value': 'Protocol v23',
'maintenance.affected_label': '受影响的服务',
'maintenance.affected_value': 'Indexing & On-chain Analytics',
'maintenance.eta_label': '预计完成时间',
'maintenance.eta_value': '5月15日',
'maintenance.note': '升级流程完成后，网站预计将恢复正常运行。感谢您的耐心与理解。'
}
